<template>
  <v-layout v-if="loading" class="white align-center text-center" style="height: 100px">
    <v-flex>
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </v-flex>
  </v-layout>
  <v-layout id="html" v-else>
      <v-flex class="grey lighten-5 pa-4">
        <v-container ref="html">
          <div v-for="(question, index) in questions" :key="index" style="margin-bottom: 8px;">
            <v-layout v-if="index === 0 || questions[index].section !== questions[index - 1].section" style="margin-bottom:10px;margin-top:24px">
              <v-flex shrink style="font-size: 22px; color: #004481; text-transform: uppercase;margin-right:16px;">
                {{ question.section }}
              </v-flex>
              <v-flex grow style="background: #004481; webkit-print-color-adjust: exact;">
              </v-flex>
            </v-layout>
            <v-layout style="margin-bottom: 8px;">
              <div style="float: left; width: 100%">
                <span style="color: #5a5a5a;">
                  <div v-if="question.subTitle" style="margin-top: 16px; margin-bottom: 8px;">
                    <v-layout align-center>
                      <v-flex shrink style="height:42px; flex-basis: 145px; min-width: 145px;max-width: 145px; padding:10px; background:red; webkit-print-color-adjust: exact;text-align: center; background: #d6a11f;color: white; text-transform: uppercase;">
                        {{ question.title.split('.')[0] }}
                      </v-flex>
                      <v-flex style="color: #043a86;font-size: 20px;line-height: 22px;padding-left: 7px;">
                        {{ question.title.replace('.', '|').split('|')[1] }}
                      </v-flex>
                    </v-layout>
                  </div>
                  <span v-if="question.subTitle">
                    {{question.subTitle | endPoint }}
                  </span>
                  <span v-else>
                    {{question.title | endPoint }}
                  </span>
                  <span style="color: #445a8e" v-if="question.type === 'checkbox'">
                    {{ question.value.map(elem => question.options[elem]).join(', ') }}
                  </span>
                  <span style="color: #445a8e" v-else-if="question.type === 'options'">
                    {{ question.options[question.value] }}
                  </span>
                  <span style="color: #445a8e" v-else-if="question.type === 'text' || question.type === 'textarea' || question.type === 'select'">
                    {{ question.value === '' ? 'Sem resposta' : question.value }}
                  </span>
                  <span style="color: #445a8e" v-else-if="question.type === 'date'">
                    {{ question.value | date }}
                  </span>
                </span>
              </div>
            </v-layout>
          </div>
        </v-container>
      </v-flex>
    </v-layout>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    questions: {
      type: Array
    }
  },
  filters: {
    date (value) {
      if (value.includes('/')) {
        return value
      } else {
        return `${value.split('-')[1]} / ${value.split('-')[0]}`
      }
    },
    endPoint (value) {
      return value[value.length - 1] === '?' || value[value.length - 1] === ':' || value[value.length - 1] === '.' ? value.replace('?', ':') : value + ':'
    }
  }
}
</script>

<style>

</style>
